import { render, staticRenderFns } from "./orderAdressList.vue?vue&type=template&id=94ca167c&scoped=true&"
import script from "./orderAdressList.vue?vue&type=script&lang=js&"
export * from "./orderAdressList.vue?vue&type=script&lang=js&"
import style0 from "./orderAdressList.vue?vue&type=style&index=0&id=94ca167c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ca167c",
  null
  
)

export default component.exports